import { Dic } from "@src/common/utils";
import i18n from "@src/common/lib/i18n";
import utils from "@src/common/utils";
const tableOption = function (staffShow, operateShow) {
  if (staffShow) {
    return {
      add: "新增",
      edit: "修改",
      view: "查看",
      page: true,
      selection: true,
      index: false,
      indexLabel: "序号",
      refreshBtn: false,
      columnBtn: false,
      stripe: true,
      addBtn: false,
      editBtn: false,
      delBtn: false,
      viewFormSlot: true,
      labelSuffix: "：",
      size: "small",
      maxHeight: "100%",
      labelWidth: "0px",
      menuAlign: "center",
      searchMenuSpan: 6,
      searchBtn: false,
      dialogHeight: 350,
      dialogWidth: "700px",
      emptyText: i18n.t("personAccess.title.noData"),
      menu: false,
      column: [
        {
          label: "所属工作组",
          prop: "securityWorkGroupName",
          addDisplay: false,
          editDisplay: false,
          viewDisplay: false,
          // viewDisplay: false,
          overHidden: true,
          search: false,
          span: 12
        },
        {
          label: "姓名",
          prop: "nickName",
          addDisplay: false,
          editDisplay: false,
          viewDisplay: false,
          // viewDisplay: false,
          clearable: true,
          overHidden: true,
          search: true,
          searchPlaceholder: "请输入姓名",
          span: 12
        },
        {
          label: "类型",
          prop: "accountType",
          search: false,
          addDisplay: false,
          editDisplay: false,
          viewDisplay: false,
          span: 12,
          viewFormatter: (row, value) => {
            if (Number(value) === 1) {
              return "保卫";
            } else if (Number(value) === 2) {
              return "员工";
            }
            return "";
          },
          formatter: (row, value) => {
            if (Number(value) === 1) {
              return "保卫";
            } else if (Number(value) === 2) {
              return "员工";
            }
            return "";
          },
          dicData: [
            {
              label: "保卫",
              value: "1"
            },
            {
              label: "员工",
              value: "2"
            }
          ]
        },
        {
          label: "性别",
          prop: "sex",
          addDisplay: false,
          editDisplay: false,
          viewDisplay: false,
          // viewDisplay: false,
          overHidden: true,
          search: false,
          searchPlaceholder: "请选择",
          span: 12,
          dicData: Dic.find("SENU092"),
          viewFormatter: (row, value) => {
            if (value) {
              return Dic.findByValue("SENU092", Number(value));
            }
            return "";
          },
          formatter: function (row, value) {
            return value ? Dic.findByValue("SENU092", value) : "";
          }
        },
        // {
        //   label: '图片',
        //   align: 'center',
        //   prop: 'img',
        //   formslot: true,
        //   span: 12,
        //   formatter: function (row, value) {
        //   },
        // },
        {
          label: "手机号码",
          // align: 'center',
          prop: "phone",
          search: true,
          addDisplay: false,
          editDisplay: false,
          viewDisplay: false,
          searchPlaceholder: "请输入电话",
          span: 12,
          clearable: true
        },
        {
          label: "邮箱地址",
          prop: "email",
          search: false,
          addDisplay: false,
          editDisplay: false,
          viewDisplay: false,
          // searchPlaceholder: '请输入部门',
          span: 12
        },
        {
          label: "", //保卫账户列表
          prop: "accountList",
          span: 24,
          formslot: true,
          hide: true
        }
      ]
    };
  }
};
export default tableOption;
